<main>
    <h4>Enviar mail de consulta</h4>
    <div class="form-group">
        <form>
            <mat-form-field class="example-full-width">
                <mat-label>Ingrese el asunto del mail</mat-label>
                <input matInput [(ngModel)]="asunto" [ngModelOptions]="{standalone: true}">
            </mat-form-field>
            <mat-form-field class="example-full-width">
                <mat-label>Ingrese el cuerpo del mail</mat-label>
                <textarea matInput [(ngModel)]="cuerpo" [ngModelOptions]="{standalone: true}"></textarea>
            </mat-form-field>
            <div class="form-foot">
                <span *ngIf="area=='cli'&&tel_ventas!=''">Telefono contacto ventas: {{tel_ventas}}</span>
                <span *ngIf="area=='pro'&&tel_prove!=''">Telefono contacto proveedores: {{tel_prove}}</span>
                <button (click)="enviarMail()" mat-fab color="primary" aria-label="Example icon button with a delete icon" matTooltip="Enviar mail">
                    <mat-icon>send</mat-icon>
                  </button>
            </div>
        </form>
    </div>
</main>
